import { Pipe, PipeTransform } from '@angular/core';
import { TransactionState } from '../../../modules/transactions/enums';

declare const $localize;

@Pipe({
    name: 'localizeTransactionState',
    standalone: false
})
export class LocalizeTransactionStatePipe implements PipeTransform {
  transform(value: TransactionState): string {
    const localizationMap = {
      [TransactionState.Initiated]: $localize`:@@transactionState.initiated:Initiated`,
      [TransactionState.Authenticating]: $localize`:@@transactionState.authenticating:Authenticating`,
      [TransactionState.Approved]: $localize`:@@transactionState.approved:Approved`,
      [TransactionState.Received]: $localize`:@@transactionState.received:Received`,
      [TransactionState.Declined]: $localize`:@@transactionState.declined:Declined`,
      [TransactionState.TimedOut]: $localize`:@@transactionState.timedOut:Timed Out`,
      [TransactionState.Routing]: $localize`:@@transactionState.routing:Routing`,
      [TransactionState.Sent]: $localize`:@@transactionState.sent:Sent`,
      [TransactionState.Reversing]: $localize`:@@transactionState.reversing:Reversing`,
      [TransactionState.Reversed]: $localize`:@@transactionState.reversed:Reversed`,
      [TransactionState.ReverseError]: $localize`:@@transactionState.reverseError:Reverse Error`,
      [TransactionState.Authorised]: $localize`:@@transactionState.authorised:Authorised`,
      [TransactionState.Repeating]: $localize`:@@transactionState.repeating:Repeating`,
      [TransactionState.OnHold]: $localize`:@@transactionState.onHold:On Hold`,
      [TransactionState.Expired]: $localize`:@@transactionState.expired:Expired`,
      [TransactionState.Cancelled]: $localize`:@@transactionState.cancelled:Cancelled`,
      [TransactionState.Refunded]: $localize`:@@transactionState.refunded:Refunded`,
      [TransactionState.Completed]: $localize`:@@transactionState.completed:Completed`,
      [TransactionState.AwaitingInvoice]: $localize`:@@transactionState.awaitingInvoice:Awaiting Invoice`,
      [TransactionState.ReadyPP]: $localize`:@@transactionState.readyPP:Ready for Payment Processor`,
      [TransactionState.Submitted]: $localize`:@@transactionState.submitted:Submitted`,
      [TransactionState.Success]: $localize`:@@transactionState.success:Success`,
      [TransactionState.SettlementFailed]: $localize`:@@transactionState.settlementFailed:Settlement Failed`,
      [TransactionState.SettlementRequested]: $localize`:@@transactionState.settlementRequested:Settlement Requested`,
      [TransactionState.SettlementCompleted]: $localize`:@@transactionState.settlementCompleted:Settlement Completed`,
      [TransactionState.Settled]: $localize`:@@transactionState.settled:Settled`,
      [TransactionState.Failed]: $localize`:@@transactionState.failed:Failed`,
      [TransactionState.Disputed]: $localize`:@@transactionState.disputed:Disputed`,
      [TransactionState.ReasonUpdated]: $localize`:@@transactionState.reasonUpdated:Reason Updated`,
      [TransactionState.Appealed]: $localize`:@@transactionState.appealed:Appealed`,
      [TransactionState.Unmatched]: $localize`:@@transactionState.unmatched:Unmatched`,
      [TransactionState.Exception]: $localize`:@@transactionState.exception:Exception`,
      [TransactionState.Voided]: $localize`:@@transactionState.voided:Voided`,
      [TransactionState.Reconciled]: $localize`:@@transactionState.reconciled:Reconciled`,
      [TransactionState.ReconciliationFailed]: $localize`:@@transactionState.reconciliationFailed:Reconciliation Failed`,
      [TransactionState.Rejected]: $localize`:@@transactionState.rejected:Rejected`,
      [TransactionState.PartiallyRefunded]: $localize`:@@transactionState.partiallyRefunded:Partially Refunded`,
      [TransactionState.Deferred]: $localize`:@@transactionState.deferred:Deferred`,
      [TransactionState.ClearingRequested]: $localize`:@@transactionState.clearingRequested:Clearing Requested`,
      [TransactionState.ClearingCompleted]: $localize`:@@transactionState.clearingCompleted:Clearing Completed`,
      [TransactionState.ClearingFailed]: $localize`:@@transactionState.clearingFailed:Clearing Failed`,
      [TransactionState.Confirmed]: $localize`:@@transactionState.confirmed:Confirmed`,
      [TransactionState.CustomerAccepted]: $localize`:@@transactionState.customerAccepted:Customer Accepted`,
    };

    return localizationMap[value] || value;
  }
}
